// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"1b792fc3","147":"e9361059","348":"d7768b71","737":"d9feb704","940":"b60f9314"}[chunkId] + ".chunk.js";
};